module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "aggregate-sub"
  }, [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.email),
      expression: "contact.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email",
      "value": ""
    },
    domProps: {
      "value": (_vm.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contact, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('cel')
    }
  }, [_c('label', {
    attrs: {
      "for": "cel"
    }
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cel),
      expression: "cel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|phone'),
      expression: "'required|phone'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "celular",
      "name": "celular",
      "title": "celular",
      "data-vv-validate-on": "blur",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.cel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "mask-tel",
      rawName: "v-mask-tel"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.tel),
      expression: "tel"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('phone'),
      expression: "'phone'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "telefone",
      "name": "telefone",
      "title": "telefone",
      "data-vv-validate-on": "blur",
      "maxlength": "14"
    },
    domProps: {
      "value": (_vm.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tel = $event.target.value
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Telefone fixo "), _c('span', [_vm._v("(opcional)")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-bfa35d02!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/aggregate-register/contact.vue
// module id = 2211
// module chunks = 1